export default __webpack_public_path__ + "static/media/bg.7816913b.jpeg";